{
  "salon-search-result-page": {
    "buttons": {
      "book-appointment": "ĐẶT LỊCH HẸN",
      "explore": "KHÁM PHÁ",
      "show-more": "XEM THÊM"
    },
    "text": {
      "salon-around": "Các tiệm lân cận"
    }
  }
}
